export default {
  "2": "главы",
  "3": "нам рисуют",
  "4": "техническая информация",
  "5": "мы рисуем",
  "6": "дополнительно",
  "7": "ссылки штоле"
}